/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AppDispatch, RootState } from 'store'
import { Input } from '../../components/Input/Input'
import { NavBar } from '../../components/NavBar/NavBar'
import {
    Flex,
    Button,
    Separator,
    H1WithBack,
    PageWrapper,
    PageFooter,
    Th,
    Tr,
} from '../../styling/GlobalStyles'
import { getIndustries } from 'features/industries/industriesSlice'
import { CancelBtn } from 'components/Button/CancelBtn'
import { ISelectValue } from 'constants/globalTypes'
import { standardFieldValidation, validateDate, validateSelect } from 'utils/validationUtils'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { TitleText } from 'styling/Typography'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Table } from '@aws-amplify/ui-react'
import { Td } from 'components/Td/Td'
import { Options } from 'components/Options/Options'
import { AddAccomodationModal, IRoom } from './AddAccommodationModal'
import { accommodationCategories, accommodationTypes } from './accommodationData'
import { AccommodationRoomsTableContainer } from './Accommodation.style'
import { editAccommodation, getSingleAccommodation } from 'features/accommodation/accommodationSlice'
import CalendarInput from 'components/CalendarInput/CalendarInput'

export const EditAccommodation = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const [invalidFields, setInvalidFields] = useState([])
    const { id } = useParams()
    const { singleAccommodation } = useSelector((state: RootState) => state.accomodation)
    const [state, setState] = useState<IAccommodationState>({
        name: '',
        address: '',
        category: null,
        type: null,
        startDate: null,
        endDate: null,
        rooms: []
    })

    const [roomModal, setRoomModal] = useState({ open: false, value: null })

    useFocusFirstInput()

    useEffect(() => {
        dispatch(getSingleAccommodation(id))
    }, [id])

    useEffect(() => {
        if (singleAccommodation) {
            setState(singleAccommodation)
        }
    }, [singleAccommodation])

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (invalidFields.length > 0) {
            toast.warn('All fields are required')
            return
        }

        const resp = await dispatch(editAccommodation(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate('/hr/accommodation')
        }
    }

    const handleSelect = (value: ISelectValue, name: string) => {
        validateSelect(value, name, setInvalidFields)
        setState({ ...state, [name]: value })
    }

    useEffect(() => {
        dispatch(getIndustries(null))
    }, [])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        standardFieldValidation(e, setInvalidFields)
        setState({ ...state, [name]: value })
    }

    const handleDate = (date: Date, name: string) => {
        validateDate(name, setInvalidFields)
        setState({ ...state, [name]: date })
    }

    const removeItem = (id: number) => {
        setState(prev => ({ ...prev, rooms: prev.rooms.filter(r => r.id !== id) }))
    }

    const handleRoom = (room: IRoom) => {
        setState(prev => {
            const copy = structuredClone(prev)
            if (room.id) {
                copy.rooms = copy.rooms.map(r => {
                    if (r.id === room.id) {
                        return room
                    }
                    return r
                })
            } else {
                copy.rooms.push({ ...room, id: new Date().getTime() })
            }
            return copy
        })
    }

    return (
        <>
            <NavBar />
            <PageWrapper>
                <H1WithBack title='Edit Accommodation' arrow />
                <Flex mt='16' gap='1rem' width='100%' >
                    <Flex column gap='1rem' width='30%' >
                        <Input labelText='Name' name='name' nomarg onChange={handleChange} value={state?.name} placeholder='Top apartment...' />
                        <Input labelText='Address' name='address' nomarg onChange={handleChange} value={state?.address} placeholder='Main Street 5...' />
                        <HonestSelectInput defaultValue={state?.category?.value} labelText='Category' name='category' onChange={handleSelect} options={accommodationCategories} nomarg />
                        <HonestSelectInput defaultValue={state?.type?.value} labelText='Type' name='type' onChange={handleSelect} options={accommodationTypes} nomarg />
                        <Flex gap='1rem' width='100%' >
                            <CalendarInput width='100%' defaultValue={state?.startDate} labelText='Start Date' name='startDate' maxDate={state?.endDate} onChange={handleDate} />
                            <CalendarInput width='100%' defaultValue={state?.endDate} labelText='End Date' name='endDate' minDate={state?.startDate} onChange={handleDate} />
                        </Flex>
                    </Flex>
                    <Flex column width='70%' >
                        <AccommodationRoomsTableContainer>
                            <Flex width='100%' between center >
                                <TitleText weight='bold' >ROOMS</TitleText>
                                <Button orange onClick={() => setRoomModal({ value: null, open: true })}> Add Room </Button>
                            </Flex>
                            {state?.rooms?.length ? <Table minWidth={0} width='100%'>
                                <Th minWidth={0} >
                                    <Td w='20%' noTooltip text='NAME' />
                                    <Td w='10%' noTooltip text='BEDS' />
                                    <Td w='65%' noTooltip text='NOTE' />
                                    <Td w='5%' />
                                </Th>
                                {state.rooms.map((r, i) => <Tr minWidth={0} key={i}>
                                    <Td w='20%' text={r.name} />
                                    <Td w='10%' text={r.numberOfBeds} />
                                    <Td cutText w='65%' text={r.notes} />
                                    <Td w='5%'>
                                        <Options item={r} title='Room' handleRemove={removeItem} />
                                    </Td>
                                </Tr>)}
                            </Table> : <NoItems title='rooms' />}
                        </AccommodationRoomsTableContainer>
                    </Flex>
                </Flex>
                {roomModal.open && <AddAccomodationModal handleRoom={handleRoom} closeModal={() => setRoomModal({ value: null, open: false })} value={roomModal.value} />}
            </PageWrapper>
            <PageFooter>
                <Flex gap='1rem'>
                    <CancelBtn />
                    <Button orange onClick={handleSubmit}>
                        Save
                    </Button>
                </Flex>
            </PageFooter>
        </>
    )
}

export interface IAccommodationState {
    id?: number
    name: string
    address: string
    category: ISelectValue,
    type: ISelectValue,
    startDate: Date
    endDate: Date
    rooms: IRoom[]
}